import { Button } from 'utoniq-ui'

import { IonInformationModal } from '@/components/organisms/functionals'
import { config } from '@/config'
import { useTranslation } from '@/core'
import { useAnalytics } from '@/core/analytics'
import { Organism } from '@/core/architecture'

type Props = {
  open: boolean
  onClose: () => void
  prepaidPointId: string
  gachaId: string
  artistId: string
  onClick: () => void
}
/**
 * @description
 * ポイント不足でチケットが購入できなかった際に表示されるモーダル
 */
export const ErrorTicketChargeModal: Organism<Props> = ({
  open,
  onClose,
  prepaidPointId,
  gachaId,
  artistId,
  onClick,
}) => {
  const { t } = useTranslation('gachaDetail')
  const { analytics } = useAnalytics()
  return (
    <IonInformationModal
      open={open}
      onClose={onClose}
      title={t('purchaseErrorTitle')}
      content={t('purchaseErrorDesc')}
      cancelText={t('cancel')}
      buttons={
        <Button
          sx={{ minWidth: 212 }}
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            onClick()
            analytics?.track('click_getPrepaidPoint', {
              applicationKey: config.applicationKey,
              name: 'gachaDetail',
              prepaidPointId,
              gachaId,
              artistId,
              type: 'modal',
            })
          }}
        >
          {t('buyPoints')}
        </Button>
      }
    />
  )
}
